import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function MaintenancePage() {
    const { t } = useTranslation();

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-gray-50 px-4 text-center">
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
                🚧 {t("maintenance.title", "Site under maintenance")}
            </h1>

            <p className="text-gray-700 max-w-xl text-lg mb-4">
                {t(
                    "maintenance.desc",
                    "We are making improvements and updates. The directory will be available again shortly."
                )}
            </p>

            <p className="text-gray-700 max-w-2xl text-sm md:text-base leading-relaxed">
                {t(
                    "maintenance.safeWork",
                    "Your work is safe. All business updates and edits are temporarily frozen during maintenance, but nothing has been lost or overwritten. Once maintenance is complete, you may continue exactly where you left off."
                )}
            </p>

            <div className="mt-6 text-sm text-gray-600">
                {t("maintenance.staffOnly", "Staff only")}:{" "}
                <Link to="/auth" className="underline">
                    {t("maintenance.adminLogin", "Admin login")}
                </Link>
            </div>
        </div>
    );
}